import { Box } from '@mui/material';

import PremiumFeatureMessage from '@/components/UpgradeToPremium/PremiumFeatureMessage';

const BasicUserPreview = () => (
  <Box
    sx={{
      position: 'relative',
      overflow: 'hidden',
      '&:before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        backgroundImage: "url('/img/preview/history-chart.png')",
        backgroundPosition: 'center',
        transform: 'scale(0.95)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        filter: 'blur(1px)',
        zIndex: 0
      }
    }}
  >
    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        backgroundColor: 'rgba(18, 22, 63, 0.80)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        alignItems: 'center',
        gap: '8px',
        height: '358px',
        '& > *': {
          fontWeight: 600
        }
      }}
    >
      <PremiumFeatureMessage />
    </Box>
  </Box>
);

export default BasicUserPreview;
